export default __webpack_public_path__ + "static/media/list_Icon.615fab0a.svg";